import PubSub from "underpub-js";
import ImgixClient from '@imgix/js-core'

const client = new ImgixClient({
	domain: 'transforming-cities.imgix.net',
});

var PropertyListings = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-PropertyListings',
	};

	$.extend(true, this.options, options);

};

PropertyListings.prototype.init = function() {

	let self = this;
	this.$listingContainer = self.options.$el.find(`.${self.options.baseClass}__listings`);

	PubSub.subscribe('mol-MapStandard:newDataAvailable', function (data) {
		self.populateListing(data.data);
	});

};

PropertyListings.prototype.populateListing = function(propertiesData) {
	let self = this;
	let markup = `<p class="${self.options.baseClass}__noResult">No Results Found.</p>`;
	if (propertiesData.length) {
		markup = self.buildPropertyMarkup(propertiesData);
	}

	self.$listingContainer.html(markup);
}

PropertyListings.prototype.buildPropertyMarkup = function(propertiesData) {
	let self = this;
	return propertiesData.map(propertyData => {
		let property = propertyData.properties;
		let image = {};
		let imageImgixUrl = '';
		if (property.smallImage?.path) {
			image = property.smallImage;
		} else if (property.wideImage?.path) {
			image = property.wideImage;
		}
		if (image.path) {
			imageImgixUrl = client.buildURL(`${image.path}`, {
				width: 500,
			})
		}

		return `
							<div class="column xsmall-12 medium-6 large-3">
								<div class="${self.options.baseClass}__listing">
									<div class="el-CardListing el-CardListing--vertical el-CardListing--small
															el-CardListing--imageAspectRatioSmall el-CardListing--light">
										<a href="${property.url}"
											 target="" class="el-CardListing__image">
											<img class="atom-ResponsiveImage atom-ResponsiveImage--bgImage"
													 alt="${image.title}"
													 src="${imageImgixUrl}"
													 >
										</a>
										<div class="el-CardListing__content">
											<div class="el-CardListing__content__top">
												<div class="el-CardListing__address">${property.address}</div>
											</div>
											<div class="el-CardListing__content__bottom">
												<a href="${property.url}"
													 target="" class="el-CardListing__headingLink">
													<h4 class="el-CardListing__heading">${property.title}</h4>
												</a>
												<div class="el-CardListing__copy">
													<p>
														${property.description}
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
	`
	}).join("");
}

export default PropertyListings;
